SNI.Application.addModule('class-results', context => {
  return {
    behaviors: ['truncate']
  };
});
